module.exports = __webpack_public_path__ + "img/alogo.1c62c819.png";